import { render, staticRenderFns } from "./RecipesDesktop.vue?vue&type=template&id=6d084220"
import script from "./RecipesDesktop.vue?vue&type=script&lang=js"
export * from "./RecipesDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports